export default "/fonts/vendor/@fontsource/inter/files/inter-vietnamese-400-normal.woff2?a1bc9a8f426924c5dea8d92f6a0a3f53";